<template>
  <el-row
    type="flex"
    justify="center"
  >
    <el-col
      :xs="{ span: 20 }"
      :sm="{ span: 20 }"
      :md="{ span: 16 }"
    >
      <el-container class="card auto-width">
        <el-row>
          <el-col>
            <span class="title">{{ strings.title }}</span>
          </el-col>
          <el-col class="py-2">
            <el-steps
              :active="0"
              finish-status="success"
              align-center
            >
              <el-step />
              <el-step />
              <el-step />
              <el-step />
              <el-step />
            </el-steps>
          </el-col>
          <el-col
            :span="12"
            :offset="6"
          >
            <el-form
              ref="form"
              :model="form"
            >
              <el-row
                type="flex"
                justify="center"
              >
                <el-col>
                  <label>{{ strings.form.termInput.label }}</label>
                  <el-form-item
                    class="mb-0"
                  >
                    <el-input
                      v-model.trim="form.searchTerm"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      class="form-input full-width"
                      autofocus
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="mt-1">
                <el-col
                  :span="12"
                  class="text-left"
                >
                  <router-link
                    to="/home"
                  >
                    <el-button
                      type="default"
                    >
                      {{ strings.form.backBtn }}
                    </el-button>
                  </router-link>
                </el-col>
                <el-col
                  :span="12"
                  class="text-right"
                >
                  <el-button
                    type="info"
                    class="form-button sm"
                    :disabled="!form.searchTerm"
                    @click.prevent="search()"
                  >
                    <span v-if="!loading">{{ strings.form.submitBtn.label }}</span>
                    <span v-if="loading">{{ strings.form.submitBtn.loading }}</span>
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SearchPage',
  data() {
    return {
      loading: false,
      form: {
        searchTerm: null
      },
      strings: {
        title: 'Swapper Search',
        form: {
          termInput: {
            label: "Search by Phone or Driver's License",
          },
          backBtn: 'Back',
          submitBtn: {
            loading: 'Searching...',
            label: 'Search'
          },
        },
        searchError: 'An error has occurred trying to search this shopper.'
      }
    };
  },
  computed: {
    ...mapGetters('shopper', ['searchError'])
  },
  methods: {
    async search() {
      const { searchTerm } = this.form;
      // Disable UI items & reset message
      this.loading = true;
      // Api call
      const resp = await this.$store.dispatch('shopper/search', { searchTerm });
      // Error Check
      if (!resp) {
        this.loading = false;
        return;
      }
      // All OK
      const { count, results } = resp;
      // Re-enable UI items
      this.loading = false;
      // Actions based upon results
      if (count === 0) {
        // Show empty results message
        this.$swal({
          type: 'info',
          title: 'No Results',
          text: `No results found for: "${this.form.searchTerm}"`
        });
      } else if (count === 1) {
        // Store this shopper and send user to Edit Page
        this.$store.dispatch('shopper/storeSelected', results[0]);
        this.$router.push('/edit-customer');
      } else {
        // Send user to results page
        this.$router.push('/search-results');
      }
    }
  }
};
</script>
